export default "__VITE_ASSET__Dl4o42$f__"